import { GET_FIXED_INPUT_SWAP_QUOTE, GET_FIXED_OUTPUT_SWAP_QUOTE } from "helpers/constants";

export const Transactions = (transactions = { FIXED_INPUT_SWAP_QUOTE: null, FIXED_OUTPUT_SWAP_QUOTE: null }, action) => {
	switch (action.type) {
		case GET_FIXED_INPUT_SWAP_QUOTE:
			return { ...transactions, FIXED_INPUT_SWAP_QUOTE: action.payload };

		case GET_FIXED_OUTPUT_SWAP_QUOTE:
			return { ...transactions, FIXED_OUTPUT_SWAP_QUOTE: action.payload };

		default:
			return transactions;
	}
};
